import { useState } from "react";
import { toast } from "sonner";
import { useSite } from "@/lib/content";
import { checkField, clean, cleanBi, rules } from "@/lib/adminApi";
import { BiFieldEditor, FieldEditor, SaveButton, SectionHeader, useSaver } from "@/pages/admin/ui";

const OPERATOR = [["legal_name", "Ticari unvan"], ["address", "Adres"], ["tax_info", "Vergi dairesi / numarası"], ["email", "E-posta"]];

export default function LegalSection() {
  const { content } = useSite();
  const [op, setOp] = useState(() => ({ ...content.operator }));
  const [privacy, setPrivacy] = useState(() => ({ ...content.privacy }));
  const [legal, setLegal] = useState(() => ({ ...content.ticket_legal }));
  const [showErrors, setShowErrors] = useState(false);
  const { save, saving } = useSaver();
  const emailError = checkField(op.email, rules.email);

  const onSave = () => {
    setShowErrors(true);
    if (emailError) return toast.error("Lütfen hatalı alanları düzeltin.");
    save([
      ["operator", Object.fromEntries(OPERATOR.map(([k]) => [k, clean(op[k])]))],
      ["privacy", { text: cleanBi(privacy.text), updated_at: cleanBi(privacy.updated_at) }],
      ["ticket_legal", { kvkk: cleanBi(legal.kvkk), terms: cleanBi(legal.terms) }],
    ]);
  };

  return (
    <section data-testid="admin-section-yasal">
      <SectionHeader title="Yasal" text="İşletmeci bilgileri ve gizlilik metni. Doğrulanana kadar canlı sitede ve alt bilgide bağlantıları gizli kalır." />
      <h3 className="text-xl font-semibold text-wood mb-3">İşletmeci bilgileri</h3>
      <div className="grid gap-4 md:grid-cols-2">
        {OPERATOR.map(([k, label]) => (
          <FieldEditor key={k} id={`operator-${k}`} label={label} multiline={k === "address"} field={op[k]} error={showErrors && k === "email" && emailError} onChange={(f) => setOp({ ...op, [k]: f })} />
        ))}
      </div>
      <h3 className="text-xl font-semibold text-wood mt-8 mb-3">Gizlilik</h3>
      <div className="grid gap-4">
        <BiFieldEditor id="privacy-text" label="Gizlilik metni" multiline field={privacy.text} onChange={(f) => setPrivacy({ ...privacy, text: f })} hint="Paragrafları boş satırla ayırabilirsiniz." />
        <BiFieldEditor id="privacy-updated" label="Son güncelleme tarihi" placeholder="örn. 14 Ekim 2026" field={privacy.updated_at} onChange={(f) => setPrivacy({ ...privacy, updated_at: f })} />
      </div>
      <h3 className="text-xl font-semibold text-wood mt-8 mb-3">Ön kayıt metinleri</h3>
      <p className="text-sm text-ink-muted mb-3">Ön kaydın canlıya açılması için ikisinin de doldurulup doğrulanması gerekir. Ziyaretçi ön kayıtta bu metinleri onaylar.</p>
      <div className="grid gap-4">
        <BiFieldEditor id="ticket-kvkk" label="KVKK aydınlatma metni" multiline field={legal.kvkk} onChange={(f) => setLegal({ ...legal, kvkk: f })} />
        <BiFieldEditor id="ticket-terms" label="Giriş koşulları" multiline field={legal.terms} onChange={(f) => setLegal({ ...legal, terms: f })} />
      </div>
      <div className="mt-6"><SaveButton onClick={onSave} saving={saving} testId="admin-save-yasal" /></div>
    </section>
  );
}
